import Typography from '@mui/material/Typography';
import {
    OlDecimal,
    OlCjk,
    OlUpperAlpha,
    UlCircle,
    LiNormal
} from '../components/customComponent/list';
import { LinkExternalSystem } from '../components/customComponent/link';


const UserTerms = () => {

    return (
        <>
            <Typography variant="h2">加入會員</Typography>
            <Typography>歡迎您加入《 HAi Report 》會員，當您使用《 HAi Report 》時，即表示您已閱讀、瞭解並同意接受本服務條款之所有內容。您於任何修改或變更後繼續使用本網站，視為您已閱讀、瞭解並同意接受該等修改或變更。如您是未滿二十歲之未成年人，則您必須在加入會員前將本服務條款請您的父母或監護人閱讀，並得到其同意，才可以註冊及使用《 HAi Report 》所提供之會員服務（包括網路服務，以下簡稱本服務）。當您使用《 HAi Report 》（以下簡稱本網站）所提供之服務時，則視為您的父母或監護人已經閱讀、了解並同意本服務條款。</Typography>

            <Typography variant="h2" mt={3}>【HAi Report 會員服務條款】</Typography>

            <OlCjk>
                <LiNormal>
                    <Typography variant="h5">註冊義務</Typography>
                    <Typography>請依註冊申請程序所提示之項目，登錄您本人正確、真實及完整之個人資料。每位會員僅能註冊登錄一個帳號，不可重複註冊登錄。當您的個人資料有異動時，請立即更新，以維持您個人資料之正確、真實及完整。如因您登錄不實資料或冒用他人名義以致於侵害他人之權利或違法時，應自負法律責任。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">會員服務與使用規則</Typography>
                    <OlDecimal>
                        <LiNormal>您於註冊程序完成並由本網站審核通過完成相關設定後，您即取得本網站會員之資格，並可以開始使用本服務。本網站有權增加、變更或取消會員服務中相關系統或功能之全部或一部之權利且無須個別通知會員；且有關現有或將來之各項服務均受本服務條款之規範。</LiNormal>
                        <LiNormal>會員在使用本服務過程中，必須遵循以下原則：</LiNormal>
                        <OlUpperAlpha>
                            <LiNormal>遵守當地有關的法律和法規；</LiNormal>
                            <LiNormal>不得為任何非法目的而使用網路服務系統；</LiNormal>
                            <LiNormal>遵守所有與網路服務有關的網路協定、規定和程式；</LiNormal>
                            <LiNormal>不得利用本網站網路服務系統進行任何可能對互聯網的正常運轉造成不利影響的行為；</LiNormal>
                            <LiNormal>不得利用本網站網路服務系統傳輸任何騷擾性的、中傷他人的、辱罵性的、恐嚇性的、庸俗淫穢的或其他任何非法的資訊資料；</LiNormal>
                            <LiNormal>不得利用本網站網路服務系統進行任何不利於本網站的行為；</LiNormal>
                            <LiNormal>如發現任何非法使用用戶帳號或帳號出現安全漏洞的情況，應立即通告本網站。</LiNormal>
                        </OlUpperAlpha>
                    </OlDecimal>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">隱私權保護</Typography>
                    <Typography>您的註冊資料及其他相關資料，均受到「《 HAi Report 》隱私權保護政策」所保護與規範。您有義務妥善保管您的帳號之機密與安全，不得洩漏、轉借或轉讓給任何第三人，如造成個人無法使用、資料喪失、錯誤、遭人竄改及本網站所屬集團之損失等情形，將由您自行承擔並負損害賠償責任。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">會員權益</Typography>
                    <Typography>本網站完成並確認您的會員申請後，本網站將提供您會員服務內容（見會員權益）。會員有義務接收本網站所發出之電子報、廣告eDM，若您確定不想要收到本網站的廣告資訊，您的免費會員資格將同時被取消，亦無法再使用本網站所提供之相關會員服務。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">服務暫停、中斷或終止</Typography>
                    <OlDecimal>
                        <LiNormal>本網站於下列情形之一時，有權隨時暫停、中斷或終止本服務之全部或一部，而無須通知會員，對於使用者不負擔任何賠償責任：</LiNormal>
                        <OlUpperAlpha>
                            <LiNormal>對於本網站相關系統設備進行遷移、更換或維護時。</LiNormal>
                            <LiNormal>因不可歸責於本網站所造成服務停止或中斷。</LiNormal>
                            <LiNormal>因不可抗力所造成服務停止或中斷。</LiNormal>

                        </OlUpperAlpha>

                        <LiNormal>對於本網站之暫停、中斷或終止，可能造成您使用上的不便、資料遺失或其他經濟及時間上之損失，您平時應採取適當的防護措施，以保障您的權益，本網站無須對會員或任何第三方承擔任何責任。</LiNormal>
                    </OlDecimal>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">免責聲明</Typography>
                    <Typography>本網站對本服務不提供任何明示或默示的擔保。本網站不保證以下事項：</Typography>
                    <OlDecimal>
                        <LiNormal>本網站將符合您的需求</LiNormal>
                        <LiNormal>本網站不受干擾、及時提供、安全可靠或免於出錯</LiNormal>
                        <LiNormal>本網站不受干擾、及時提供、安全可靠或免於出錯</LiNormal>
                        <LiNormal>您經由本服務取得之任何服務、資訊或其他資料將符合您的期望您自本網站或經由本服務取得之建議和資訊，無論其為書面或口頭，均不構成本服務之保證。</LiNormal>
                    </OlDecimal>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">會員內容之保留或揭露</Typography>
                    <Typography>本網站基於下列理由會將會員所傳送、張貼或發表之內容保留或揭露：</Typography>
                    <OlDecimal>
                        <LiNormal>司法或警察機關偵查犯罪需要時。</LiNormal>
                        <LiNormal>政府機關依法律程序要求時。</LiNormal>
                        <LiNormal>因會員之行為違反法令或本服務條款之規定時。</LiNormal>
                        <LiNormal>基於維護公益或保護本網站所屬集團或他人權利。</LiNormal>
                        <LiNormal>事先獲得會員的明確授權。</LiNormal>
                        <LiNormal>本網站可能會與第三方合作向會員提供相關的網路服務，在此情況下，如該第三方同意承擔與本網站同等的保護會員隱私的責任，則本網站可將會員的註冊資料等提供給第三方。</LiNormal>
                    </OlDecimal>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">違約賠償</Typography>
                    <Typography>會員同意保障和維護本網站及其他會員與第三方的權益，如因會員違反有關法律、法規或本服務協定項下的任何條款，而給本網站或任何第三人造成損失，會員同意承擔由此造成的損害賠償責任。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">智慧財產權</Typography>
                    <Typography>本網站上所使用或提供之軟體、程式及內容（包括但不限於文字、說明、圖畫、圖片、圖形、檔案、頁面設計、網站規劃與安排等）之專利權、著作權、商標權、營業秘密、專門技術及其他智慧財產權均屬本網站或其他權利人所有，非經權利人事先書面授權同意，會員不得重製、公開傳輸、公開播送、公開上映、改作、編輯、出租、散布、進行還原工程、解編、反向組譯、或其他方式之使用，如有違反，會員應對本網站所屬集團負損害賠償責任 (包括但不限於訴訟費用及律師費用等) 。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">服務條款之增訂及修改本網站之服務</Typography>
                    <Typography>條款如有增訂或修改，您同意自該修訂條款於本網站公告之時起受其拘束，本網站將不對會員個別通知。如您於公告後繼續使用本服務，則視為您已經同意該修訂條款。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">準據法及管轄法院</Typography>
                    <OlDecimal>
                        <LiNormal>關於本服務條款之解釋或適用，以中華民國之法律為準據法。</LiNormal>
                        <LiNormal>會員因使用本服務而與本網站所生之爭議，同意先本誠信原則解決之，如有訴訟之必要時，同意以台灣台北地方法院為第一審管轄法院。</LiNormal>
                    </OlDecimal>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">通知與送達</Typography>
                    <Typography>本服務項下所有的通知均可通過重要頁面公告、電子郵件等方式進行；該等通知於發送之日視為已送達收件人。</Typography>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">其他規定</Typography>
                    <OlDecimal>
                        <LiNormal>本服務構成雙方對本網站之約定事項及其他有關事宜的完整服務，除本服務條款規定的之外，未賦予各方其他權利。</LiNormal>
                        <LiNormal>如本服務條款中的任何條款無論因何種原因完全或部分無效或不具有執行力，其餘條款仍應有效並且有約束力。</LiNormal>
                        <LiNormal>本服務條款中的標題僅為方便而設，在解釋時應被忽略。</LiNormal>
                    </OlDecimal>

                    <Typography variant="h5">《保障隱私權聲明》</Typography>
                    <Typography>本網站致力提供專業華文數位廣告資訊，當您使用本網站特定服務時，基於對網路個人資料保護及線上隱私權的支持，您所填寫的資料將受下列聲明保障：</Typography>
                    <UlCircle>
                        <LiNormal>個人基本資料的取得：本網站為提供廣大網友更貼心的需求，會依您所登錄的會員資料進行統計分析，並不定時寄送第一手數位廣告商情資訊，並不另外收取 E-mail 傳輸費用，當您希望使用數位廣告產業數據、市場解讀服務及其他註冊會員服務功能項目時，本網站將要求您填寫個人基本資料並妥善保護之。本網站將記錄您連線的位址及相關網站內的瀏覽活動資料，惟僅供作網站流量分析和網路行為調查，以便於改善日後網站的服務品質，此類資訊只用於進行數據統計分析，不涉及個人身分資料追蹤。本網站所提供之隱私權保障聲明，不包括本網站內所連結之其他網站及網頁。如您有任何疑問或使用上的問題，
                            您可與本網站客服中心 (<LinkExternalSystem href="mailto:tda@tradeserv.com">tda@tradeserv.com</LinkExternalSystem>) 聯絡。</LiNormal>
                    </UlCircle>

                    <Typography variant="h5">《HAi Report 會員註冊須知》</Typography>
                    <UlCircle>
                        <LiNormal>當您註冊為本網站會員時，我們建議您謹慎選擇您個人登入帳號 (Login ID)；您註冊時填寫的 E-Mail 即為您的帳號。</LiNormal>
                        <LiNormal>若您忘記登入帳號 (Login ID)，可由會員服務中的查詢功能查詢。</LiNormal>
                        <LiNormal>本網站為保障您的會員權利，特別提醒您所提供的帳號必須為所使用正確的 E-Mail；當會員申請審核完成時，密碼將寄至您的 E-Mail，若有任何變更時，請主動通知本網站或上網 
                            (<LinkExternalSystem href="https://report.haitech.com.tw/" target="_blank">https://report.haitech.com.tw/</LinkExternalSystem>) 更正。</LiNormal>
                        <LiNormal>本網站為配合服務需要，將保留修改本會員註冊須知權利；當本會員註冊須知有任何修改時，將會公告於網站
                             (<LinkExternalSystem href="https://report.haitech.com.tw/" target="_blank">https://report.haitech.com.tw/</LinkExternalSystem>)。</LiNormal>
                    </UlCircle>
                </LiNormal>

                <LiNormal>
                    <Typography variant="h5">會員特別約定事項</Typography>
                    <Typography>若會員具有歐盟會員國或其法律適用國等國籍 (包含但不限於列支敦斯登、冰島等) ，在此清楚且明確同意，提供予本網站之所有資訊 (包含但不限於個人資料等) ，應確保業已符合會員所屬國家及中華民國之各項法令 (包含但不限於 GDPR 等) 。若因違反前述約定而導致產生任何問題，會員應自負法律責任。</Typography>
                </LiNormal>

                {/* <LiNormal>
                    <Typography variant="h5">標題</Typography>
                    <Typography>無序號</Typography>
                    <OlDecimal>
                        <LiNormal>數字標號</LiNormal>
                        <OlUpperAlpha>
                            <LiNormal>英文標號</LiNormal>
                        </OlUpperAlpha>
                    </OlDecimal>
                </LiNormal>


                <UlCircle>
                    <LiNormal>空心圓</LiNormal>
                </UlCircle> */}

            </OlCjk>
        </>
    )
}

export default UserTerms;